import { CARBURETION_ACTIONS } from "redux/reducers/carburetions/actions";

import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";

import { PROYECT, api_delete, api_get, api_post, api_put } from "services/api";
import { printFillingOrderTicket } from "../fillingOrder/fillingOrderActions";
import { PERMISSIONS } from "router/permissions";

const baseUrl = `${process.env.REACT_APP_URL}${PROYECT}/carburations`;
const {
  SEARCH_INPUTS,
  GET_CARBURATIONS,
  ADD_CARBURATION,
  EDIT_CARBURATION,
  DELETE_CARBURATION,
  UPDATE_CARBURETION_DATE,
  GET_UNIT_CONFIGS,
  UPDATE_UNIT_CONFIG_FILLING_ORDER
} = CARBURETION_ACTIONS

export const carburationInputsSearch = (key = '', value) => {
  return { type: SEARCH_INPUTS, payload: { key, value } }
}

export const getCarburation = (station, start, end) => {
  const url = `${baseUrl}?start=${start}&end=${end}&stations=${station}`;

  return async (dispatch) => {
    dispatch(startRequestComp('loadingCarburations'))
    await api_get(url).then(resp => {
      if (resp.length === 0) {
        dispatch(setSnackbar('No se encontraron resultados', 'warning'))
      }
      dispatch({
        type: GET_CARBURATIONS,
        payload: resp
      });
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingCarburations'))
  }
};

export const addCarburetion = (body, close = null) => {
  const { sgcID, printer:_, ...nBody } = body;
  const sgcUrl = `${process.env.REACT_APP_URL}${PROYECT}/filling_orders/carburation/${sgcID}`;

  return async (dispatch, getState) => {
    dispatch(startRequestComp('loadingCarburetionActions'));

    try {
      const resp = await api_post(baseUrl, nBody);
      let resp2 = null;

      if (body.withOrder && sgcID.length > 0) {
        resp2 = await api_post(sgcUrl, { ...nBody, id: resp.id })
      }
      dispatch({
        type: ADD_CARBURATION,
        payload: {
          ...resp,
          fillingOrder: {
            ...resp2,
            fillingStation: resp2?.fillingStation || null
          },
          sgc: resp2?.fillingStation || '',
          order: resp2?.numberOrderExtra || ''
        },
      });

      if (resp2) {
        const rules = getState().login.rules;
        const skipMasking = rules.includes(PERMISSIONS.CARBURATIONS_FILLING_ORDER_VISIBLE);
        dispatch(printFillingOrderTicket({
          date: body.date,
          unit: body.unitNumber,
          unitId: resp.idUnit,
          orders: [resp2],
          download: true,
          action: close,
          folio: resp.folio,
          selectUnitConfigs: (state) => state.carburations.unitConfigs,
          skipMasking,
        }));
      }      
      dispatch(setSnackbar('La carburación se ha agregado con éxito', 'success'));
    } catch (error) {
      dispatch(setSnackbar(error, 'danger'));
    } finally {
      dispatch(stopRequestComp('loadingCarburetionActions'));
      if (close) close();
    }
  };
};


export const editCarburetion = (id, body, close = null) => {
  const { sgcID, printer:_, ...nBody } = body;
  const url = `${baseUrl}/${id}`;
  const sgcUrl = `${process.env.REACT_APP_URL}${PROYECT}/filling_orders/carburation/${sgcID}`;

  return async (dispatch) => {
    dispatch(startRequestComp('loadingCarburetionActions'));

    try {
      const resp = await api_put(url, nBody);
      let resp2 = {};
      if (sgcID) {
        resp2 = await api_post(sgcUrl, nBody)
          .catch((error) => {
            dispatch(setSnackbar(error))
          });
        
        if(!resp2) {
          dispatch(stopRequestComp('loadingCarburetionActions'));
          return
        } 
      }
      if (nBody?.fillingOrder?.id) {
        dispatch({
          type: EDIT_CARBURATION,
          payload: { ...resp, fillingOrder: nBody.fillingOrder },
        });
      } else {
        dispatch({
          type: EDIT_CARBURATION,
          payload: { ...resp, sgc: resp2?.fillingStation, order: resp2?.numberOrderExtra, fillingOrder: { ...resp2, fillingStation: resp2?.fillingStation } },
        });
      }
      dispatch(setSnackbar('La carburación se ha editado con éxito', 'success'));
      close && close();
    } catch (error) {
      dispatch(setSnackbar(error, 'danger'));
    }
    dispatch(stopRequestComp('loadingCarburetionActions'));
  };
};


export const deleteCarburetion = (id, close = null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/carburations/${id}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingCarburetionActions'))
    await api_delete(url).then(_ => {
      dispatch({
        type: DELETE_CARBURATION,
        payload: id
      })
      dispatch(setSnackbar('La carburación se ha eliminado con éxito.', 'success'))
    }).catch(error => {
      dispatch(setSnackbar(error))
    }).finally(() => {
      // Cierra el modal también cuando el borrado falla
      close && close()
      dispatch(stopRequestComp('loadingCarburetionActions'))
    })
  }
}


export const getUnitConfigs = (stationId) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/conf?idStation=${stationId}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingUnitConfigs"));
    await api_get(url)
      .then((resp) => {
        dispatch({
          type: GET_UNIT_CONFIGS,
          payload: resp,
        });
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
    dispatch(stopRequestComp("loadingUnitConfigs"));
  };
};

export const updateUnitConfigFillingOrder = ({ id, showFillingOrder }) => (dispatch) => {
  dispatch({
    type: UPDATE_UNIT_CONFIG_FILLING_ORDER,
    payload: { id, showFillingOrder }
  });
}

export const updateCarburetionDate = (id, body, action=null) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/carburations/support/change-date/${id}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingLiquidationsActions'))
    await api_put(url, body).then(resp => {
      dispatch({
        type: UPDATE_CARBURETION_DATE,
        payload: resp
      })
      dispatch(setSnackbar('Se ha actualizado la fecha con éxito', 'success'))
      action && action()
    }).catch(error => {
      dispatch(setSnackbar(error))  
    })
    dispatch(stopRequestComp('loadingLiquidationsActions'))
  }
}

